const prjnoteActionTypes = {
  SET_PRJNOTES: "SET_PRJNOTES",
};

export default prjnoteActionTypes;
